module.exports = __webpack_public_path__ + "img/case9-jpg.f769e0fa.jpg";